export default __webpack_public_path__ + "static/media/Baz-Hahadur.544e4fdd.jpg";